import React from 'react';
export function HeroSection() {
  return <section className="pt-[25px] pb-[30px] px-[15px]" data-id="element-142">
      <div className="max-w-[650px] mx-auto" data-id="element-143">
        <p className="text-[#EF4444] font-[800] uppercase text-[13px] mb-[10px] tracking-[0px]" data-id="element-144">
          ⚠️ Hacés café todos los días… pero nunca sale igual. ⚠️
        </p>

        <h1 className="text-[23px] leading-[1.2] mb-[15px] font-[800] text-[#111827] font-['Montserrat']" data-id="element-145">
          <strong data-id="element-146">La Biblia del Café</strong>
          <br data-id="element-147" />
          <span className="relative inline-block" data-id="element-148">
            <span className="relative z-10 text-[#8B4513] font-[900] text-[26px]" style={{
            background: 'linear-gradient(180deg, transparent 50%, rgba(210,180,140,0.4) 50%)',
            padding: '0 6px',
            animation: 'highlightPulse 2s ease-in-out infinite'
          }} data-id="element-149">
              En 7 días
            </span>
          </span>{' '}
          vas a dejar de adivinar y vas a dominar el café consistente en casa,{' '}
          <span className="bg-gradient-to-r from-[#D2B48C] to-transparent px-[5px] py-0" data-id="element-150">
            sin volverte barista
          </span>{' '}
          ni comprar más equipo.
        </h1>

        <p className="text-[16px] leading-[1.5] max-w-[600px] mx-auto text-[#6B7280] mb-[20px]" data-id="element-151">
          Un sistema visual, paso a paso, que te muestra exactamente qué ajustar
          cuando una taza sale agria, amarga o aguada.
        </p>

        <div className="mb-[20px] rounded-[12px] overflow-hidden shadow-[0_0_25px_rgba(139,69,19,0.6),0_8px_25px_rgba(0,0,0,0.2)]" data-id="element-152">
          <img src="https://app.heylloyd.io/public/files/openrouter-generated-image-1770512678546.png" alt="La Biblia del Café" className="w-full block rounded-[12px]" data-id="element-153" />
        </div>

        <a className="block w-full max-w-[380px] mx-auto bg-gradient-to-br from-[#8B4513] to-[#A0522D] text-white border-none p-[16px] text-[18px] font-[700] rounded-[50px] cursor-pointer shadow-[0_8px_20px_rgba(139,69,19,0.3)] text-center no-underline uppercase font-['Montserrat'] animate-pulse-custom hover:transform hover:-translate-y-[3px] hover:scale-[1.02] hover:shadow-[0_8px_20px_rgba(139,69,19,0.5)] transition-all duration-400" href="#elige-tu-plan" data-id="element-154">
          👉 QUIERO LA BIBLIA DEL CAFÉ
        </a>

        <div className="text-[11px] mt-[10px] text-[#6B7280] text-center" data-id="element-155">
          ⚡ Descarga inmediata · Oferta por tiempo limitado
        </div>
      </div>
    </section>;
}